































import {Vue, Component, Watch} from "vue-property-decorator";
import {namespace} from "vuex-class";

import * as services from '@/services/services.ts';
import {Languages} from '@/constants/locale';
import {DEFAULT_LANGUAGE} from "@/constants/locale";
import {IUserData} from "@/models/ApiModels";
import {OTHER_ROUTES, HISTORY} from "@/constants/routes";

import LanguageSelector from "@/views/components/FormInputs/LanguageSelector.vue";
import {ANALYTIC_CLICKS} from "@/services/Analytics";

const userDataModule = namespace("userData");

@Component({
  name: "UserMenu",
  components: {
    LanguageSelector,
  },
})
export default class UserMenu extends Vue {
  private language: Languages = DEFAULT_LANGUAGE;

  @userDataModule.Getter("getProfile")
  private user!: IUserData;

  @userDataModule.Action("setLanguage")
  private setLanguage!: (lang: Languages) => Promise<any>;

  @Watch("language")
  private languageWatcher() {
    this.setLanguage(this.language);
  }

  private get getUrlParameters(): string {
    return `phone=${encodeURIComponent(this.user.phone_number)}`;
  }

  private created() {
    this.language = this.user.language;
  }

  private goToProfile() {
    ANALYTIC_CLICKS.myProfile(this.$gtag);
    this.$router.push({name: OTHER_ROUTES.PROFILE });
  }

  private logout() {
    services.authService.clearToken();
  }

  private goHistory() {
    ANALYTIC_CLICKS.history(this.$gtag);
    this.$router.push({name: HISTORY.START });
  }

  private earningsClick() {
    ANALYTIC_CLICKS.earnings(this.$gtag);
    this.$uiBus.emit("drawer:hide");
    this.$uiBus.emit("dialog:infoMoney:show");
  }

  private goToDefaultHub() {
    ANALYTIC_CLICKS.defaultSmartPoint(this.$gtag);
    this.$uiBus.emit("drawer:hide");
    this.$uiBus.emit("dialog:defaultHub:show");
  }
}
